import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Container, Row, Col, Form, FormGroup, Label, Input, Alert, Badge, Button as Buttons } from 'reactstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { doGetBankAccounts, doPostBankTransferConfirm } from '../../actions/paymentAction';
import { doFetchUserBankAccount } from '../../actions/postalCodeAction';
import moment from 'moment-timezone';
import FormFeedback from '../Forms/FormFeedback';
import { InputDatetime } from '../Forms/Input';
import Button from '../Forms/ButtonLoading';
import { isValidDate, isNumeric, dotRegex, commaRegex, whiteSpaceRegex } from '../../helpers/regex';
import { getQueryParamsUrl } from '../../helpers/url';
import Analytics from '../../services/Analytics';
import withScrollTo from "../hoc/withScrollTo";
moment.tz.setDefault("Asia/Jakarta");
// import { convertToRupiah } from '../../utils';

const DATE_FORMAT = 'YYYY-MM-DD HH:mm:00';
const DATE_FORMAT_LABEL = 'YYYY-MM-DD HH:mm';

const CONFIRMATION_SUCCESS_MSG = 'Terima kasih telah melakukan konfirmasi pembayaran. Admin kami akan langsung melakukan pengecekan dalam waktu 24 jam.'

const AlertSuccess = ({ status_code, message, children }) => {
  return (
    status_code === 200 ?
      <Alert className="no-border-radius" color="success" style={{ textAlign: 'center' }}>
        <h4 className="alert-heading">Well done!</h4>
        <p>{`${message}`}</p>
        <hr />
        <Link to='/' className="link link-dark">
          <Buttons className="btn-green flat">Lanjutkan Berbelanja</Buttons>
        </Link>
      </Alert>
      :
      children
  )
}

class PagePaymentConfirm extends Component {
  constructor(props) {
    super(props);
    const params = Object.assign({ transferAmount: '' }, getQueryParamsUrl(this.props.location.search));
    this.state = {
      invoice_number: this.props.match.params.invoice || '',
      transfer_amount: params.transferAmount,
      name: '',
      transfer_date: moment().format(DATE_FORMAT),
      bank_account_id: 0,
      bank_accounts: [
        { value: '', label: 'Pilih Rekening Kick Avenue' }
      ],
      _submit: false,
      _isOpenError: false,
      _error: null,
      _statusCode: 0,
      _successMessage: ''
    }
    this._handleChange = this._handleChange.bind(this);
    this._onSubmit = this._onSubmit.bind(this);
    this._onCloseError = this._onCloseError.bind(this);
    this._handleNominalChange = this._handleNominalChange.bind(this);
  }

  componentDidMount() {
    this.props.getBankAccountList();
    let { isLogged } = this.props.dataAuth;
    if (isLogged) {
      this.props.getUserBankAccount();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { paymentConfirmation } = nextProps.dataPayment;
    if (nextProps.dataPayment.bankAccounts.isFetch === false
      && nextProps.dataPayment.bankAccounts.isFetch !== this.props.dataPayment.bankAccounts.isFetch) {
      if (nextProps.dataPayment.bankAccounts.status_code === 200) {
        const { data } = nextProps.dataPayment.bankAccounts;
        const bankAccounts = data.map(bank => ({ value: bank.id, label: `${bank.account_number} - ${bank.bank_name} - ${bank.account_name}` }));
        this.setState({ bank_accounts: [{ value: '', label: 'Pilih Rekening Kick Avenue' }, ...bankAccounts], bank_account_id: bankAccounts.length ? bankAccounts[0].value : 0 });
      }
    }
    if (nextProps.userBankAccount.isFetch === false
      && nextProps.userBankAccount !== this.props.userBankAccount.isFetch && this.props.dataAuth.isLogged) {
      if (nextProps.userBankAccount.data.length && nextProps.userBankAccount.status_code === 200) {
        const { data } = nextProps.userBankAccount;
        this.setState({ name: data[0].account_name });
      }
    }

    if (paymentConfirmation.isSubmit === false
      && paymentConfirmation.isSubmit !== this.props.dataPayment.paymentConfirmation.isSubmit
      && this.state._submit === true
    ) {
      if (paymentConfirmation.error) {
        this.setState({ _submit: false, _error: { ...paymentConfirmation.error }, _isOpenError: true })

      }
      else {
        this.setState({ _submit: false, _statusCode: paymentConfirmation.status_code, _successMessage: CONFIRMATION_SUCCESS_MSG })
      }
    }
  }

  _onCloseError() {
    this.setState({ _isOpenError: false });
  }

  _handleChange(e) {
    const lastState = { ...this.state };
    lastState[e.target.name] = e.target.value;
    this.setState({ ...lastState });
  }

  _handleNominalChange(e) {
    const lastState = { ...this.state };
    const emptyChar = '';
    lastState[e.target.name] = e.target.value
      .replace(whiteSpaceRegex, emptyChar)
      .replace(dotRegex, emptyChar)
      .replace(commaRegex, emptyChar);
    this.setState({ ...lastState });
  }

  _handleDatePickerChange(value, name) {
    const lastState = { ...this.state }
    lastState[name] = (value !== null && value['_isAMomentObject']) ? value.format(DATE_FORMAT) : value;
    this.setState({ ...lastState });
  }

  _validateForm() {
    let errors = {};
    if (this.state.invoice_number === '')
      errors['invoice_number'] = errors['invoice_number'] !== undefined ? [...errors.invoice_number, 'Harap isi no. order Anda.'] : ['Harap isi no. order Anda.'];
    if (this.state.transfer_amount === '')
      errors['transfer_amount'] = errors['transfer_amount'] !== undefined ? [...errors.transfer_amount, 'Harap isi jumlah nominal'] : ['Harap isi jumlah nominal.'];
    if (!isNumeric(this.state.transfer_amount))
      errors['transfer_amount'] = errors['transfer_amount'] !== undefined ? [...errors.transfer_amount, 'Nominal harus angka'] : ['Nominal harus angka'];
    if (this.state.name === '')
      errors['name'] = errors['name'] !== undefined ? [...errors.name, 'Harap isi nama pemilik rekening.'] : ['Harap isi nama pemilik rekening.'];
    if (this.state.transfer_date === null || this.state.transfer_date === '')
      errors['transfer_date'] = errors['transfer_date'] !== undefined ? [...errors.transfer_date, 'Harap isi pilih tanggal transfer.'] : ['Harap isi pilih tanggal transfer.'];
    if (!isValidDate(this.state.transfer_date))
      errors['transfer_date'] = errors['transfer_date'] !== undefined ? [...errors.transfer_date, 'Format tanggal yang anda masukkan tidak valid.'] : ['Format tanggal yang anda masukkan tidak valid.'];
    if (this.state.bank_account_id === 0 || this.state.bank_account_id === '')
      errors['bank_account_id'] = errors['bank_account_id'] !== undefined ? [...errors.transfer_date, 'Harap isi pilih rekening tujuan.'] : ['Harap isi pilih rekening tujuan.'];
    if (Object.keys(errors).length) {
      this.setState({
        _error: { errors: { ...errors }, status_code: 422, message: 'Please fulfill your form' },
        _isOpenError: true
      })
    }
    return errors;
  }

  _onSubmit(e) {
    e.preventDefault();
    this.setState({ _error: null, _isOpenError: false })
    if (!Object.keys(this._validateForm()).length) {
      const { invoice_number, transfer_amount, name, transfer_date, bank_account_id } = this.state;
      const { userdata, isLogged } = this.props.dataAuth;

      this.setState({ _submit: true }, () => {
        Analytics.recordPaymentCompletion(
          invoice_number.trim(),
          transfer_amount.trim(),
          name,
          transfer_date,
          bank_account_id,
          isLogged? userdata.id : null
        )
        this.props.submit({
          invoice_number: invoice_number.trim(),
          transfer_amount: transfer_amount.trim(),
          name,
          transfer_date,
          bank_account_id
        })
      })
    }
  }

  _hasError(name) {
    if (this.state._error !== null && this.state._error.status_code === 422) {
      return Object.keys(this.state._error.errors).filter(err => err === name).length > 0;
    }
    return false;
  }

  _renderError() {
    if (this.state._error !== null) {
      const { status_code, message } = this.state._error;
      switch (status_code) {
        case 422:
          return (
            <Alert className="no-border-radius" style={{ paddingBottom: 15 }} isOpen={this.state._isOpenError} toggle={this._onCloseError} color="danger">
              <div style={{ marginTop: 5 }}>
                <strong>Oh snap!</strong> Please fullfill your form.
              </div>
            </Alert>
          )
        default:
          return (
            <Alert className="no-border-radius" style={{ paddingBottom: 20 }} isOpen={this.state._isOpenError} toggle={this._onCloseError} color="danger">
              <div style={{ marginTop: 5 }}>
                <strong>Oh snap!</strong> {message}. Please inform our friendly staff via Whatsapp: +6281210005425
              </div>
            </Alert>
          )
      }
    }
    return '';
  }

  render() {
    return (
      <Container className="main-container page-container" id="payment-confirm-page">
        <Row>
          <Col xs={12} md={{ size: 8, offset: 2 }}>
            <h5 className="text-center">Konfirmasi Pembayaran</h5>
            <p>Mohon untuk melakukan konfirmasi <b>(khusus untuk metode pembayaran bank transfer)</b> setelah berhasil melakukan pemesanan produk dari website konfirmasi
            guna mempercepat proses pembelian. Isi form dibawah ini sesuai dengan detail yang diminta.
            </p>
          </Col>
          <Col xs={12} md={{ size: 6, offset: 3 }}>
            <AlertSuccess status_code={this.state._statusCode} message={this.state._successMessage}>
              <div>
                {this._renderError()}
                <Form id="payment-confirm-form" onSubmit={this._onSubmit}>
                  <FormGroup>
                    <Label>ORDER ID *</Label>
                    <Input
                      className={classNames("form-control__input--black-lighter", { 'is-invalid': this._hasError('invoice_number') })}
                      value={this.state.invoice_number}
                      placeholder="No. Invoice contoh: KA-XXXXXX-XXX-XXXXXX"
                      name="invoice_number"
                      onChange={this._handleChange}
                    />
                    <FormFeedback errors={this.state._error !== null ? this.state._error.errors : undefined} field="invoice_number" />
                  </FormGroup>
                  <FormGroup>
                    <Label>Jumlah Yang Dibayarkan *</Label>
                    <Input
                      className={classNames("form-control__input--black-lighter", { 'is-invalid': this._hasError('transfer_amount') })}
                      value={this.state.transfer_amount}
                      placeholder="Jumlah nominal yang dibayar"
                      name="transfer_amount"
                      onChange={this._handleNominalChange}
                    />
                    <FormFeedback errors={this.state._error !== null ? this.state._error.errors : undefined} field="transfer_amount" />
                  </FormGroup>
                  <FormGroup>
                    <Label>Nama Pemilik Rekening *</Label>
                    <Input
                      className={classNames("form-control__input--black-lighter", { 'is-invalid': this._hasError('name') })}
                      value={this.state.name}
                      placeholder="Nama pemilik rekening"
                      name="name"
                      onChange={this._handleChange}
                    />
                    <FormFeedback errors={this.state._error !== null ? this.state._error.errors : undefined} field="name" />
                  </FormGroup>
                  <FormGroup>
                    <Label>Tanggal Transaksi * <i>({DATE_FORMAT_LABEL})</i> </Label>
                    <InputDatetime
                      className={classNames({ 'is-invalid': this._hasError('name') })}
                      inputProps={{ className: classNames('form-control form-control__input--black-lighter', { 'is-invalid': this._hasError('transfer_date') }), placeholder: 'Pilih tanggal transfer...' }}
                      value={moment(this.state.transfer_date)}
                      onChange={(date) => this._handleDatePickerChange(date, 'transfer_date')}
                    />
                    <FormFeedback errors={this.state._error !== null ? this.state._error.errors : undefined} field="transfer_date" />
                  </FormGroup>
                  <FormGroup>
                    <Label>Dibayarkan Ke Rekening *</Label>
                    <Input
                      className={classNames("form-control__input--black-lighter", { 'is-invalid': this._hasError('bank_account_id') })}
                      value={this.state.bank_account_id}
                      type="select"
                      name="bank_account_id"
                      onChange={this._handleChange}>
                      {
                        this.state.bank_accounts.map((item, index) => <option value={item.value} key={index}>{item.label}</option>)
                      }
                    </Input>
                    <FormFeedback errors={this.state._error !== null ? this.state._error.errors : undefined} field="bank_account_id" />
                  </FormGroup>
                  <p>
                    <small>* Wajib diisi.</small>
                  </p>
                  <FormGroup className="d-none">
                    <Label>Upload Bukti Transfer</Label>
                    <Input />
                  </FormGroup>
                  <FormGroup>
                    <Row>
                      <Col xs={12} md={{ size: 6, offset: 3 }}>
                        <Button
                          loadingText="SUBMITTING"
                          block
                          size="lg"
                          className="btn-green bold"
                          isLoading={this.state._submit}
                        >
                          <div>
                            SUBMIT
                            {
                              this.state._error !== null ?
                                <Badge color="danger" style={{ borderRadius: 0, marginLeft: '.5rem' }}>
                                  {this.state._error.status_code === 422 ? Object.keys(this.state._error.errors).length : 1}
                                </Badge>
                                : null
                            }
                          </div>
                        </Button>
                      </Col>
                    </Row>
                  </FormGroup>
                </Form>
              </div>
            </AlertSuccess>
          </Col>
        </Row>
      </Container>
    )
  }
}

const mapDistpatchToProps = dispatch => ({
  getBankAccountList: () => dispatch(doGetBankAccounts()),
  getUserBankAccount: () => dispatch(doFetchUserBankAccount()),
  submit: (payload) => dispatch(doPostBankTransferConfirm(payload))
})

const mapStateToProps = state => ({
  dataPayment: state.dataPayment,
  userBankAccount: state.dataPostalCode.userBankAccount,
  dataAuth: state.dataAuth
})

export default connect(mapStateToProps, mapDistpatchToProps)(withScrollTo(PagePaymentConfirm))
